import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { clamp } from "@egr/wcf/modules/utils/math";
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
import { AbstractInteractorTool } from './tools';
import { RoomElementInteractors } from "./interactors";
import { EditRoomElement } from './../cmd/EditRoomElement';
import { RoomElementSnapping } from './RoomElementSnapping';
export class ScaleArena extends AbstractInteractorTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mCommand = null;
        this.mLengthFeedback = null;
    }
    initialize(pRoomElement, pScaleMode) {
        this.mRoomElement = pRoomElement;
        const tREparam = this.mRoomElement.Params;
        this.mCommand = new EditRoomElement(this.mRoomManager, this.mRoomElement);
        this.mArenaSnapping = new RoomElementSnapping(this.mRoomManager);
        this.mInitialPos = new Vector3(0, 0, 0);
        this.mInitialFieldLengthDef = this.mRoomElement.Params.arenaFieldLength * tREparam.arenaLaneScale;
        this.mInitialFieldLength = this.mRoomElement.Params.arenaFieldLength * tREparam.arenaLaneScale * tREparam.arenaFieldScale;
        this.mMode = pScaleMode;
        this.prepareSnapping();
        this.mRoomManager.beginInteraction();
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        this.mRoomManager.endInteraction();
        super.stop();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        this.mInitialPos = pPos;
    }
    updatePointerPosition(pPos) {
        const tRE = this.mRoomElement;
        const tDistX = pPos.x - this.mInitialPos.x;
        const tnewFieldLength = this.mInitialFieldLengthDef + tDistX;
        const tnewArenaScale = tnewFieldLength / this.mRoomElement.Params.arenaFieldLength;
        if (this.mMode === ScaleArena.Mode.ScaleComplete) {
            tRE.setArenaScale(tnewArenaScale, true);
        }
        if (this.mMode === ScaleArena.Mode.ScaleLength) {
            const tfieldLength = this.mRoomElement.Params.arenaFieldLength * tRE.Params.arenaLaneScale;
            const tnewLength = this.mInitialFieldLength + tDistX * 2;
            const tnewArenaFieldScale = clamp(tnewLength / tfieldLength, 0.01, 50);
            tRE.Params.arenaFieldScale = tnewArenaFieldScale;
            this.mRoomElement.updateGeometry();
            this.mRoomManager.cutOverlappingShapes();
        }
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null) {
            this.mView.viewer.requestRenderFrame();
        }
    }
    finish() {
        if (this.mCommand != null) {
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mRoomElement.notifyChange(ElementChangedFlags.Properties);
                this.mCommand = null;
                this.stop();
            });
        }
    }
    prepareSnapping() {
        super.prepareSnapping();
        /*
        if (this.mMode !== ScaleArena.Mode.ScaleArena) {
            this.mMeasureSnapping.prepareSnapping(this.mRoomElement, this.mMode === ScaleArena.Mode.MoveStart ?
                mdl.MeasureEnding.End : mdl.MeasureEnding.Start);
        }
        */
    }
    prepareFeedback() {
        super.prepareFeedback();
        this.mLengthFeedback = new RoomElementInteractors(this.mRoomManager, this.mRoomElement);
        this.mLengthFeedback.showInteractors(false);
    }
    updateFeedback() {
        super.updateFeedback();
        if (this.mLengthFeedback != null) {
            this.mLengthFeedback.showInteractors(false);
        }
    }
    clearFeedback() {
        super.clearFeedback();
        this.mArenaSnapping.clear();
        if (this.mLengthFeedback != null) {
            this.mLengthFeedback.clear();
            this.mLengthFeedback = null;
        }
    }
}
//add nested types
(function (ScaleArena) {
    let Mode;
    (function (Mode) {
        Mode[Mode["ScaleComplete"] = 0] = "ScaleComplete";
        Mode[Mode["ScaleLength"] = 1] = "ScaleLength";
    })(Mode = ScaleArena.Mode || (ScaleArena.Mode = {}));
})(ScaleArena || (ScaleArena = {}));
